<div class="card" *blockUI="'section-block'">
  <div class="row align-items-center mt-1 mb-1">
    <div class="col-md-6 col-12">
      <a href="#/admin/company-create">
        <button class="btn btn-primary ml-1" rippleEffect>
          <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
            class="d-none d-sm-inline-block">Yeni Firma Ekle </span>
        </button>
      </a>
    </div>
    <div class="col-md-6 col-12 d-flex justify-content-end">
      <div class="d-flex align-items-center">
        <label class="d-flex align-items-center mr-1">
          <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="50">50</option>
          </select>
        </label>
        <label class="d-flex align-items-center mr-1">
          <input type="search" placeholder="Bul" class="form-control"
            (keyup)="filterUpdate($event)" (search)="filterUpdate($event)" />
        </label>
      </div>
    </div>
  </div>

  <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;"
    [limit]="selectedSize" [messages]="{ 
    emptyMessage: 'Veri Yok',
    totalMessage: 'Toplam', 
    selectedMessage: 'Seçili'
  }" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true"
    (activate)="onActivate($event)">
    <ng-template ngx-datatable-cell-template let-row="row">
      <a href="#/admin/company/{{row.id}}">{{row.name}}</a>
    </ng-template>

    <ngx-datatable-column name="Şirket Adı" width="200">
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{row.companyName | slice:0:20}}{{ row.companyName.length > 20 ? '...' : '' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Kategori" width="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.categoryName ?? "Yok"}}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="E-Mail" width="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.mail | slice:0:30}}{{ row.mail?.length > 30 ? '...' : '' }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Telefon No" width="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        {{row.phoneNumber ?? "Yok"}}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Etiketler" width="200">
      <ng-template ngx-datatable-cell-template let-row="row">
        <mat-chip-list *ngIf="row.labels && row.labels.length > 0">
          <div class="badge badge-pill badge-light-info">
            {{ row.labels[0].labelName }}
            {{getFormattedLength(row.labels)}}
          </div>
        </mat-chip-list>
        <span *ngIf=" !row.labels || row.labels.length===0">Yok</span>
      </ng-template>
    </ngx-datatable-column>


    <!-- <ngx-datatable-column [width]="40" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-row="row">
            <div ngbDropdown container="body">
              <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
              </button>
              <div ngbDropdownMenu>
                <a href="#/admin/company/{{row.id}}" ngbDropdownItem
                  class="d-flex align-items-center"><i data-feather="file-text" class="mr-50"></i>Görüntüle</a>
                 <a href="javascript:;" ngbDropdownItem
                    ><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Delete</a
                  > 
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column> -->
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div class="datatable-footer-inner">
          <div class="page-count">
            Toplam Veri {{ totalCount }}
          </div>
          <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
            (pageChange)="onPageChange($event)">
            <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                [class]="'font-weight-bolder'"></span>
            </ng-template>
            <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                [class]="'font-weight-bolder'"></span></ng-template>
          </ngb-pagination>
        </div>

      </ng-template>

    </ngx-datatable-footer>
  </ngx-datatable>
</div>